angular
	.module 'App.Component'
	.component 'integrationLog',
		{
			templateUrl: '@component/integration-log/integration-log.view.html'
			controller: 'IntegrationLogComponent'
			controllerAs: 'integrationLog'
			bindings:
				integrationId: '<'
		}

class IntegrationLogComponent extends AbstractController
	@register()
	@inject '$uibModal',
		'IntegrationRepository'
		'IntegrationLogRepository'
		'BACKEND_INTEGRATION_LOG_STATUS'

	initialize: ->
		@logs = []
		@errors = []

		@filterDTO = new FilterDTO({
			pageSize: 25
			count: 0
			page: 1
			sortProperty: 'update_time'
		})

		@search()

	search: ->
		query = @filterDTO.getQuery()
		query.criteria 'integration_id', '=', @integrationId
		query.with('integration_errors')

		@IntegrationLogRepository
			.getEntitiesWithCount query
			.then (response) =>
				@filterDTO.count = response.count
				@logs = response.data
				@hideErrors()

	retry: (log) ->
		data =
			integration_id: log.integration_id
			entity: log.entity
			entity_id: log.owner_id

		@IntegrationRepository
			.retry data
			.then =>
				@errors = []
				@search()

	toggleLogErrors: (log) ->
		currentState = log.showErrors
		@hideErrors()
		log.showErrors = !currentState

	hideErrors: ->
		for log in @logs
			log.showErrors = false
